/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=07d27f8d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=07d27f8d&lang=css"

import exportComponent from "/Users/sujian/Desktop/lihu/吕楠中医挂号平台/voice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__